// Brand Identity Showcase Page
// Route: /brand-showcase (for internal review)

import React from 'react';
import { BrandIdentityShowcase } from '../design-system/examples/BrandIdentityShowcase';
import { Box } from '@mui/material';

const BrandShowcasePage: React.FC = () => {
  return (
    <Box sx={{ minHeight: '100vh', backgroundColor: '#F8FAFC' }}>
      <BrandIdentityShowcase />
    </Box>
  );
};

export default BrandShowcasePage;